import styled from 'styled-components';

const Warning = styled.p`
  color: var(--warning-500);
  font-size: 0.9rem;
`;
export default Warning;
